<template>
  <div class="card">
    <div class="list list--nested">
      <div class="list__header py-2 pr-2 pl-6 flex justify-between items-baseline">
        <div class="text-gray-700 capitalize">
          {{ $te('runSchedule') ? $t('runSchedule') : 'run schedule' }}
        </div>
      </div>
      <div class="list__body">
        <div class="list__item p-6 space-y-2">
          <span class="text-sm text-gray-700 capitalize">
            {{ $te('startingDate') ? $t('startingDate') : 'starting date' }}
          </span>
          <div v-if="campaign.dateStartForHumans">
            {{ campaign.dateStartForHumans }}
          </div>
          <div v-else>
            {{ $te('notSet') ? $t('notSet') : 'not set' }}
          </div>
        </div>
        <div class="list__item p-6 space-y-2">
          <span class="text-sm text-gray-700 capitalize">
            {{ $te('endingDate') ? $t('endingDate') : 'ending date' }}
          </span>
          <div v-if="campaign.dateEndForHumans">
            {{ campaign.dateEndForHumans }}
          </div>
          <div v-else>
            {{ $te('notSet') ? $t('notSet') : 'not set' }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CampaignSchedule',
  props: {
    campaign: {
      type: Object,
      required: true,
    },
  },
};
</script>
